import type { ResolvedView, TabHostApi } from '@hibro/shared';
import { createContext } from 'react';

import type { UiRegistry } from '../../runtime/ui-registry';

export interface TabHostRuntimeValue {
  /** AuxiliaryBar host. Header actions and the tab controller stay on this one. */
  readonly host: TabHostApi;
  /** Editor instance tabs resolve chrome through this host, not `host`. */
  readonly editorHost?: TabHostApi;
  readonly views: readonly ResolvedView[];
  readonly registry: UiRegistry;
  readonly executeCommand: (id: string, ...args: unknown[]) => Promise<unknown>;
}

export const TabHostRuntimeContext = createContext<TabHostRuntimeValue | null>(
  null,
);
